import { Content } from '../storyblok/types';
import getFaqPageSchema from './faq-page';

const schema = (storyContent: Content): Array<string> => {
  const result = [getFaqPageSchema(storyContent)].filter(Boolean);
  return result.map((data) => JSON.stringify(data));
};

export default schema;
